<template>
    <div class="product">
        <productDetails></productDetails>
    </div>
</template>

<style scoped>
    .newCustomer{
        background : #F5F7FA;
    }
</style>

<script>
    import productDetails from '@/components/product_details_form.vue';

    export default {
        name: 'product',
        data() {
            return {
            }
        },
        components: {
            productDetails
        }
    }
</script>